module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/147assets/fonts/e18bbf611f2a2e43afc071aa2f4e1512.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
// module id = 753
// module chunks = 4